// Shared formatting for the Other Earnings breakdown (Qty / Rate / Total)
// printed by the payslip PDF templates.
//
// `get-payslip-details` returns each Other Earnings row with the working values
// it was calculated from - `method` ("Hours" / "Shift" / "Fixed"), `quantity`
// and `per_day` (the rate) - alongside the amount, mirroring the keys the
// individual-employee-payrun payload uses. These helpers read either key
// spelling so the same renderer works against both APIs.

const isEmpty = (value) =>
  value === undefined || value === null || value === "";

const toNumber = (value) => {
  if (isEmpty(value)) {
    return null;
  }
  const parsed = parseFloat(`${value}`.replace(/,/g, ""));
  return Number.isNaN(parsed) ? null : parsed;
};

const formatDecimal = (value, decimals = 2) =>
  value.toLocaleString("en-IN", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

export const getComponentQuantity = (item) =>
  item?.quantity ?? item?.qty ?? item?.count;

export const getComponentRate = (item) => item?.per_day ?? item?.rate;

// Quantity is either an HH:MM string for hours-based components ("99:00") or a
// plain number of shifts/units. Print HH:MM untouched, format the rest.
export const formatQuantity = (value) => {
  if (isEmpty(value)) {
    return "-";
  }
  if (typeof value === "string" && value.includes(":")) {
    return value.trim();
  }
  const parsed = toNumber(value);
  return parsed === null ? `${value}`.trim() : formatDecimal(parsed);
};

// A zero rate means the component was entered as a fixed amount rather than
// earned at a rate, so print "-" the way the Earning Summary screen does.
export const formatRate = (value) => {
  const parsed = toNumber(value);
  return parsed === null || parsed === 0 ? "-" : formatDecimal(parsed);
};
